import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    functionalName: yup.string().required('Functional name is required'),
    functionalDescription: yup.string().nullable()
})
    .required();
export const AddFunctionalModal = (props) => {
    const { onRequestClose, itemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            functionalName: itemToEdit ? itemToEdit.functionalName : '',
            functionalDescription: itemToEdit ? itemToEdit.functionalDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ functionalName, functionalDescription }) => {
        setIsSubmitting(true);
        console.log('submitting');
        const data = {
            functionalName: functionalName == '' ? null : functionalName,
            functionalDescription: functionalDescription == '' ? null : functionalDescription
        };
        console.log(data);
        if (itemToEdit) {
            const response = await axios.post('/api/carePlan/editFunctional', {
                functionalId: itemToEdit.id,
                functionalName: data.functionalName,
                functionalDescription: data.functionalDescription
            });
            const new_functional = response.data.data.new_functional;
            const updatedFunctional = {
                id: new_functional.id,
                patientId: new_functional.patient_id,
                carePlanId: new_functional.care_plan_id,
                functionalName: new_functional.functional_name,
                functionalDescription: new_functional.functional_description,
                updatedAt: new Date(new_functional.updated_at),
                deletedAt: new Date(new_functional.deleted_at),
                createdAt: new Date(new_functional.created_at),
                isEditable: new_functional.is_editable,
                month: new_functional.month
            };
            onSuccess(updatedFunctional);
        }
        else {
            const response = await axios.post('/api/carePlan/addFunctional', {
                patientId: patientId,
                functionalName: data.functionalName,
                functionalDescription: data.functionalDescription
            });
            const new_functional = response.data.data.new_functional;
            const updatedFunctional = {
                id: new_functional.id,
                patientId: new_functional.patient_id,
                carePlanId: new_functional.care_plan_id,
                functionalName: new_functional.functional_name,
                functionalDescription: new_functional.functional_description,
                updatedAt: new Date(new_functional.updated_at),
                deletedAt: new Date(new_functional.deleted_at),
                createdAt: new Date(new_functional.created_at),
                isEditable: new_functional.is_editable,
                month: new_functional.month
            };
            onSuccess(updatedFunctional);
        }
        setIsSubmitting(false);
    };
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: {
                m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }, id: "customized-dialog-title" },
            itemToEdit ? 'Edit Functional Limitation' : 'Add Functional Limitation',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Functional Limitation"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "functionalName", presets: props.presets, category: "functional", field: "functional", placeholder: "e.g., Limited mobility due to neuropathy" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('functionalDescription'), defaultValue: itemToEdit?.functionalDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-problem" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, itemToEdit ? 'Edit Functional Limitation' : 'Add Functional Limitation')))))));
};
